// FlagChip — clickable pill that opens the FlagDetail route for the given
// flag id. Minimal for now: this is the pill shape; the modal/route lives
// in the Flags task. Deliberately doesn't fetch anything — it's a leaf
// component sprinkled throughout the app, so lookups happen at the caller.
import { Link } from "wouter";
import { cn } from "@/lib/cn";

interface FlagChipProps {
  flagId: string;
  className?: string;
}

export function FlagChip({ flagId, className }: FlagChipProps) {
  return (
    <Link href={`/flags/${encodeURIComponent(flagId)}`} className="no-underline">
      <span
        className={cn(
          "inline-flex items-center rounded-full border border-border-hover bg-card px-2 py-0.5 font-mono text-[11px] text-text-secondary hover:border-text hover:text-text",
          className,
        )}
      >
        {flagId}
      </span>
    </Link>
  );
}
